import { DataSource, Layout, SearchPanel, Table, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutStandardCodeList extends Layout {
    searchPanelStandardCodes: SearchPanel;
    sourceEdiStandardCodeList: DataSource;
    tableStandardCode: Table;
    textboxDescription: Textbox;
    textboxElementId: Textbox;
    textboxStandardCode: Textbox;
    textboxVersion: Textbox;
}
